const interfacePhrases = {
    rate_limited: 'Rate limited',
    limit_exceeded: 'Limit exceeded',
    used: 'Used',
    identifier: 'Identifier',
    verification: 'Verification',
    messages: 'Messages',
    data: 'Data',
    custom: 'Custom',
    management_api: '{{product}} Management API',
    management_api_role_description: 'This built-in role grants access to the management API.',
    client_credentials: 'Client credentials',
    authentication_request: 'Authentication request',
    callback: 'Authentication callback',
    help_title: 'iden Help Center',
    help_subtitle: 'Guidance without leaving your workspace',
    open_help: 'Open full help page',
    close_help: 'Close help',
    about: 'About & open source',
    open_navigation: 'Open navigation',
    close_navigation: 'Close navigation',
    development_enabled: 'Development features enabled',
    beta: 'Beta',
    impersonation: 'Impersonation',
    key: 'Key',
    value: 'Value',
    error: 'Error',
    details: 'Technical details',
    callback_failed: "We couldn't complete the sign-in callback.",
    back_sign_in: 'Back to sign in',
    powered_by: 'Powered by',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'QR code',
    sample_title: 'Want to see a sample?',
    sample_description: 'Explore a sample application that uses this guide.',
    sample_action: 'View sample',
    further_readings: 'Further reading',
    complete_guide: 'Complete guide',
    custom_domains_notice: 'After adding <a>custom domains</a>, you can use the following endpoint: <code>{{endpoint}}</code>.',
    my_project: 'My project',
    my_secret: 'My secret',
    my_token: 'My token',
    role_example: 'Viewer',
    reset_retry: 'Reset configuration and retry',
    open_dev_panel: 'Open developer panel',
    close_dev_panel: 'Close developer panel',
    configuration: 'Configuration',
    app_id: 'Application ID',
    extra_parameters: 'Additional sign-in parameters',
    prompt: 'Authentication prompt',
    scope: 'Scope',
    resource: 'Resource',
    resources_space_delimited: 'Resources (space separated)',
    sign_out_to_apply: 'Sign out to apply changes.',
    refresh_token_grant: 'Refresh token grant',
    organization_id: 'Organization ID',
    console_result: 'See the browser console for the result.',
    request_token: 'Request token',
    user_info: 'User information',
    get_id_token_claims: 'Get ID token claims',
    fetch_user_info: 'Fetch user information',
    device_initializing: 'Initializing device authorization…',
    device_success: "You've successfully signed in to the demo app.",
    sign_in_information: 'Your sign-in information:',
    email: 'Email',
    username: 'Username',
    user_id: 'User ID',
    sign_out_demo: 'Sign out of demo',
    device_expired: 'Device code expired',
    generic_error: 'Something went wrong',
    device_expired_description: 'The device code has expired. Try again to get a new code.',
    sign_in_title: 'Sign in to your account',
    scan_instruction: 'Scan the QR code, or open this address on another device:',
    one_time_code: 'Enter the one-time code',
    token_info: 'Token information',
    get_access_token: 'Get access token',
    context_unavailable: 'Unable to load account information.',
    not_initialized: 'Account information is not initialized.',
    not_set: 'Not set',
    configured: 'Configured',
    password: 'Password',
    phone: 'Phone number',
    search_help: 'Search help',
    language: 'Language',
    menu: 'Menu',
    compatibility_notice: 'Compatibility note: inherited Logto SDK, package, protocol, component, and request-header names remain unchanged.',
    source: 'Source',
    upstream_repository: 'Upstream repository',
    current_fork: 'Current repository',
    license_notice: 'iden is based on Logto, open-source software licensed under the Mozilla Public License 2.0.',
    about_description: 'Product information and open-source attribution.',
    page_not_found: 'Page not found',
    page_not_found_description: 'The page is unavailable. Return to the help center to continue.',
    introduction: 'Introduction',
    quick_starts: 'Quick starts',
    integration: 'Integration',
    end_user_flows: 'End-user flows',
    authorization: 'Authorization',
    user_management: 'User management',
    security: 'Security',
    customization: 'Customization',
    connectors: 'Connectors',
    organizations: 'Organizations',
    self_hosting: 'Self-hosting',
    continue: 'Continue',
    loading: 'Loading…',
    save: 'Save',
    saved: 'Saved',
    try_again: 'Try again',
    client_id: 'Client ID',
    client_secret: 'Client secret',
    redirect_uri: 'Redirect URI',
    status: 'Status',
    type: 'Type',
    permissions: 'Permissions',
    token_data: 'Token data',
    context_data: 'Context data',
    jwt_extra_claims: 'Additional token claims',
    action_result: 'Action result',
    social_account_already_linked: 'This social account is already linked.',
};
export default Object.freeze(interfacePhrases);
